import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { AIButtonTextGrey } from '../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'

import { QA_NAME_REFRESH_SUMMARY_BUTTON } from './ProfileAISummaryWidgetFooterRefreshButton.constants'

import RefreshIcon from '../../../icons/refresh.svg'

function ProfileAISummaryWidgetFooterRefreshButton({
  className,
  loading,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <AIButtonTextGrey
      beforeIconProps={{
        Icon: RefreshIcon,
        height: ICON_HEIGHT_20,
      }}
      className={className}
      height={BUTTON_HEIGHT_24}
      isLoading={loading}
      qaName={QA_NAME_REFRESH_SUMMARY_BUTTON}
      text={t('Common.RefreshButtonTextKey')}
      tooltip={t('Notification.ProfileAISummaryWidgetOutdatedKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClick}
    />
  )
}

export default ProfileAISummaryWidgetFooterRefreshButton
